import { useABTestVariant } from '@app-studio-web/ui/contexts/ABTestContext'
import { setABTestVariantInContext } from '@app-studio-web/ui/helpers/variantContext'
import { useEffect } from 'react'
import { Outlet, useSearchParams } from 'react-router-dom'

const VALID_VARIANTS = ['baseline', 'v1', 'v2'] as const

type Variant = (typeof VALID_VARIANTS)[number]

function isValidVariant(value: string | null): value is Variant {
  return VALID_VARIANTS.includes(value as Variant)
}

// Real users reach sign-up by client-side navigation out of onboarding, so the
// variant resolved there is still in context. A direct hit on /sign-up/* has
// only Confidence to go on, which makes the variant layouts impossible to
// review locally. ABTestSectionOutlet honours ?variant= for the same reason on
// /onboarding and /checkout; this gives sign-up the same override without the
// path-prefix redirects, which sign-up does not use.
export default function SignUpOutlet() {
  const [searchParams] = useSearchParams()
  const { setVariant, variant } = useABTestVariant()

  const variantParam = searchParams.get('variant')

  useEffect(() => {
    if (!isValidVariant(variantParam) || variant === variantParam) return

    setVariant(variantParam)
    setABTestVariantInContext(variantParam)
  }, [setVariant, variant, variantParam])

  return <Outlet />
}
